<template>
  <v-container fluid>
    <v-row class="justify-center">
      <v-col md="6" sm="12">
        <h2>Verträge nach Debitor</h2>
        <br>
        <a :href="route('csv.export.contract.index')" target="_blank">
          <v-btn color="primary">
            CSV Download
          </v-btn>
        </a>
        <h2>Ressourcen nach Verträgen</h2>
        <br>
        <a :href="route('csv.export.cpu-ram-storage')" target="_blank">
          <v-btn color="primary">
            CSV Download
          </v-btn>
        </a>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Admin'
// import NotificationsDemo from '@/Components/Demo/CreateNotification'

export default {
   metaInfo: { title: 'Dashboard' },

   components: {
      // NotificationsDemo
   },

   layout: (h, page) => h(Layout, [page]),

   props: {
      //
   },

   data () {
      return {}
   },
}
</script>
